(function (angular) {

  function Routes($routeProvider, RouteConfig){
    $routeProvider
      .when('/:module/:page/:id', {
        templateUrl: function($routeParams) {
          var route = `${$routeParams.module}/${$routeParams.page}-detail`;
          var hasConfig = RouteConfig.hasOwnProperty(route) ? RouteConfig[route] : false;
          var template = `/utils/src/manager/components/${$routeParams.module}/${$routeParams.page}-detail.html`;
          if(hasConfig) return template;
        },
        controller: 'DynamicCtrl'
      })
      .when('/:module/:page', {
        templateUrl: function($routeParams) {
          var route = `${$routeParams.module}/${$routeParams.page}`;
          var hasConfig = RouteConfig.hasOwnProperty(route) ? RouteConfig[route] : false;
          var template = `/utils/src/manager/components/${$routeParams.module}/${$routeParams.page}.html`;
          if(hasConfig) return template;
        },
        controller: 'DynamicCtrl'
      })

  }
  Routes.$inject = ['$routeProvider', 'RouteConfig'];

  // Export
  angular.module('app.full').config(Routes);

})(angular);
